var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCameraLogo = function SvgCameraLogo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    x: 0,
    y: 0,
    viewBox: "0 0 472 472",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M467.102 26.527a10.009 10.009 0 0 0-9.899-.18L348.906 85.48V50c-.031-27.602-22.398-49.969-50-50H50C22.398.031.031 22.398 0 50v197.422c.031 27.601 22.398 49.969 50 50h248.906c27.602-.031 49.969-22.399 50-50v-34.836l108.301 59.133A10.001 10.001 0 0 0 472 262.94V35.125a9.997 9.997 0 0 0-4.898-8.598zM328.898 247.426c-.015 16.562-13.437 29.98-30 30H50c-16.563-.02-29.98-13.438-30-30V50c.02-16.559 13.438-29.98 30-30h248.906c16.559.02 29.98 13.441 30 30zM452 246.09 348.906 189.8v-81.534L452 51.98zm0 0",
    fill: "#ffffff",
    "data-original": "#000000",
    className: ""
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCameraLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cameraLogo.82203309.svg";
export { ForwardRef as ReactComponent };